import React, { useState, useEffect } from 'react';

const FormCrearMateria = ({ handleClose }) => {
  const [data, setData] = useState({
    nombre: "",
    precio: "",
    categoria: "",
    disponible: "", // Valor por defecto: disponible
    imagen: null
  });
  
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await fetch('http://localhost:8080/api/categoria');
        if (!response.ok) {
          throw new Error('Error al obtener las categorías');
        }
        const data = await response.json();
        setCategorias(data);
      } catch (error) {
        console.error(error);
      }
    };
    
    fetchCategorias();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    setData((prevUser) => ({
      ...prevUser,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('nombre', data.nombre);
    formData.append('categoria', data.categoria);
    formData.append('precio', data.precio);
    formData.append('disponible', data.disponible); // Agregar disponibilidad al formData
    formData.append('imagen', data.imagen);

    fetch("http://localhost:8080/api/producto", {
      method: "POST",
      headers: {
        'authorization': sessionStorage.getItem('token')
      },
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        console.log("producto creado:", data);
        alert('producto creado con exito');
        handleClose();
      })
      .catch(error => console.error("Error al crear el producto: ", error));
  };

  return (
    <>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form onSubmit={handleSubmit}>
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  id="floatingMateria"
                  value={data.nombre}
                  placeholder='Nombre'
                  onChange={handleInputChange}
                  name='nombre'
                  required
                />
                <label htmlFor="floatingMateria" ><h4>Nombre</h4></label>
              </div>
              <br></br>

              <div className="form-floating">
                <select
                  className="form-control"
                  id="floatingtipo"
                  value={data.categoria}
                  onChange={handleInputChange}
                  name='categoria'
                  required
                  placeholder='Categoria'
                >
                  <option value="">Seleccione una opción</option>
                  {categorias.map(categoria => (
                    <option key={categoria.id} value={categoria.id}>{categoria.nombre.toUpperCase()}</option>
                  ))}
                </select>
                <label htmlFor="floatingtipo"><h4>Categoria</h4></label>
              </div>

              <br></br>
              <div className="form-floating">
                <input
                  type="number"
                  className="form-control"
                  id="floatingprecio"
                  value={data.precio}
                  placeholder='Precio'
                  onChange={handleInputChange}
                  name='precio'
                  required
                />
                <label htmlFor="floatingprecio" ><h4>Precio</h4></label>
              </div>

              <br></br>

              <div className="form-floating">
                <select
                  className="form-control"
                  id="floatingdispo"
                  value={data.disponible}
                  onChange={handleInputChange}
                  name='disponible'
                  required
                  placeholder='Disponibilidad'
                >
                   <option value="">Seleccione una opción</option>
                  <option value="0">Disponible</option>
                  <option value="1">No disponible</option>
                </select>
                <label htmlFor="floatingdispo"><h4>Disponibilidad</h4></label>
              </div>

              <br></br>
              <div className="form-floating">
                <input
                  type="file"
                  className="form-control"
                  id="floatingimagen"
                  placeholder='Imagen'
                  onChange={handleInputChange}
                  name='imagen'
                />
                <label htmlFor="floatingimagen" ><h4>Imagen</h4></label>
              </div>
              <br></br>

              <button type="submit" className="btn btn-primary">Crear</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormCrearMateria;
